export const breakpoints = {
  largeScreen: 1481,
  wideScreenMin: 1280,
  wideScreenMax: 1480,
  mobileScreenMax: 1279,
  mobilePortraitMax: 480,
  portraitDeviceMax: 767,
  desktopScreenMin: 1280,
  tabletScreenLandscapeMin: 768,
  tabletScreenLandscapeMax: 1279,
  tabletScreenPortraitMin: 768,
  tabletScreenPortraitMax: 1024
};

export const device = {
  largeScreen: `(min-width: ${breakpoints.largeScreen}px)`,
  wideScreen: `(min-width: ${breakpoints.wideScreenMin}px) and (max-width: ${breakpoints.wideScreenMax}px)`,
  maxWideScreen: `(max-width: ${breakpoints.wideScreenMax}px)`,
  mobileScreen: `(max-width: ${breakpoints.mobileScreenMax}px)`,
  mobilePortrait: `(max-width: ${breakpoints.mobilePortraitMax}px)`,
  portraitDevice: `(max-width: ${breakpoints.portraitDeviceMax}px)`,
  desktopScreen: `(min-width: ${breakpoints.desktopScreenMin}px)`,
  tabletScreenLandscape: `(min-width: ${breakpoints.tabletScreenLandscapeMin}px) and (max-width: ${breakpoints.tabletScreenLandscapeMax}px) and (orientation: landscape)`,
  tabletScreenPortrait: `(min-width: ${breakpoints.tabletScreenPortraitMin}px) and (max-width: ${breakpoints.tabletScreenPortraitMax}px)`
};
